
import index from 'airship/page/index'

async function loadModules() {
  const loaded = []
  for (const module of window.modules) {
    if (module === 'behaviors_index') {
    const m = await import('../lib/behaviors/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_empty') {
    const m = await import('../lib/page/empty.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_accounts') {
    const m = await import('../lib/page/accounts/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_activity_index') {
    const m = await import('../lib/page/activity/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_add_on_management') {
    const m = await import('../lib/page/manage-add-ons/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_android_notification_channels_detail') {
    const m = await import('../lib/page/android-notification-channels/detail.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_api-keys') {
    const m = await import('../lib/page/api-integrations/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_config') {
    const m = await import('../lib/page/app_config.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_content_templates') {
    const m = await import('../lib/page/content-templates/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_credentials') {
    const m = await import('../lib/page/credentials/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_experiment_report') {
    const m = await import('../lib/page/experiments/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_advanced_segment_builder') {
    const m = await import('../lib/page/advanced-segment-builder/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_advanced_segment_list') {
    const m = await import('../lib/page/advanced-segment-list/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_list') {
    const m = await import('../lib/page/app_list/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_message_search') {
    const m = await import('../lib/page/message-search/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_settings_dashboard') {
    const m = await import('../lib/page/app-settings-dashboard/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_web_migration') {
    const m = await import('../lib/page/app-web-migration/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_apple_news') {
    const m = await import('../lib/page/apple-news/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_apple_news_composer') {
    const m = await import('../lib/page/apple-news/composer.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auto_upgrade_management') {
    const m = await import('../lib/page/auto-upgrade-management/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_audience_attributes') {
    const m = await import('../lib/page/audience/attributes/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_brochure') {
    const m = await import('../lib/page/brochures/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_checkout') {
    const m = await import('../lib/page/checkout/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_allowlist_editor') {
    const m = await import('../lib/page/allowlist/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_connect') {
    const m = await import('../lib/page/connect/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_contact_management') {
    const m = await import('../lib/page/zephyrus/react.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel') {
    const m = await import('../lib/page/control_panel/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_side_nav') {
    const m = await import('../lib/page/control_panel/side-nav/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_accengage') {
    const m = await import('../lib/page/control_panel/accengage/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_announcements') {
    const m = await import('../lib/page/control_panel/announcements/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_company') {
    const m = await import('../lib/page/control_panel/company/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_company_feature-flags') {
    const m = await import('../lib/page/control_panel/company/feature-flags/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_composerdata') {
    const m = await import('../lib/page/control_panel/composerdata/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_composer_templates') {
    const m = await import('../lib/page/control_panel/composer_templates.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_configs-records') {
    const m = await import('../lib/page/control_panel/configs-records/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_connect') {
    const m = await import('../lib/page/control_panel/company/connect.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_email') {
    const m = await import('../lib/page/control_panel/email/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_app-custom-domain') {
    const m = await import('../lib/page/control_panel/custom-domain/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_app-looker-playground') {
    const m = await import('../lib/page/control_panel/looker-playground/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_app-email') {
    const m = await import('../lib/page/control_panel/app-email/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_app_sms') {
    const m = await import('../lib/page/control_panel/app-sms/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_app-open-platforms') {
    const m = await import('../lib/page/control_panel/app-open-platforms/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_health-check') {
    const m = await import('../lib/page/control_panel/company/health-check.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_insight') {
    const m = await import('../lib/page/control_panel/insight/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_internal_permissions') {
    const m = await import('../lib/page/control_panel/internal-permissions/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_change-history') {
    const m = await import('../lib/page/control_panel/change-history/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_predictive_features') {
    const m = await import('../lib/page/control_panel/predictive_audiences/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_push') {
    const m = await import('../lib/page/control_panel/push.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_search') {
    const m = await import('../lib/page/control_panel/search/search-page.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_sentry-test') {
    const m = await import('../lib/page/control_panel/sentry-test.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_template') {
    const m = await import('../lib/page/control_panel/template.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_templates') {
    const m = await import('../lib/page/control_panel/templates.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_usage') {
    const m = await import('../lib/page/control_panel/company/usage.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_user_apps') {
    const m = await import('../lib/page/control_panel/user-apps/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_control_panel_employee-user-audit') {
    const m = await import('../lib/page/control_panel/employee-user-audit/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_custom-events') {
    const m = await import('../lib/page/custom-events/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_open-ai') {
    const m = await import('../lib/page/open-ai/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_dashboard') {
    const m = await import('../lib/page/dashboard.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_deep_links_detail') {
    const m = await import('../lib/page/deep_links/detail.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_demo_app_invite') {
    const m = await import('../lib/page/demo-app-invite/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_demo_app_invite_add_app') {
    const m = await import('../lib/page/demo-app-invite/add_app.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_ecomm_upgrade') {
    const m = await import('../lib/page/ecomm-upgrade/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_email_editor') {
    const m = await import('../lib/page/email-editor/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_flight_deck') {
    const m = await import('../lib/page/flight-deck/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_feeds') {
    const m = await import('../lib/page/feeds.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_goatzart') {
    const m = await import('../lib/page/goatzart/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_goals') {
    const m = await import('../lib/page/goals/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_holdout-groups') {
    const m = await import('../lib/page/holdout-groups/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_feature_flags') {
    const m = await import('../lib/page/feature_flags/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_experiments_overview') {
    const m = await import('../lib/page/experiments_overview/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_favorites') {
    const m = await import('../lib/page/favorites/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_app_settings') {
    const m = await import('../lib/page/app-settings/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_insight_dashboards') {
    const m = await import('../lib/page/insight/dashboards.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_insight_onboarding') {
    const m = await import('../lib/page/insight/onboarding.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_journeys-experiment') {
    const m = await import('../lib/page/journeys-experiments/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_journeys-hq') {
    const m = await import('../lib/page/journeys-hq/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_lists_edit') {
    const m = await import('../lib/page/static-lists/edit.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_lists_list') {
    const m = await import('../lib/page/static-lists/list.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_orchestration_strategies') {
    const m = await import('../lib/page/orchestration_strategies/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_partner_integrations') {
    const m = await import('../lib/page/partner-integrations/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_push_templates') {
    const m = await import('../lib/page/push-templates/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_push_templates_create') {
    const m = await import('../lib/page/push-templates/create.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-cert-management') {
    const m = await import('../lib/page/reach/cert-management/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-control-panel-template') {
    const m = await import('../lib/page/control_panel/reach-template.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-projects-dashboard') {
    const m = await import('../lib/page/reach/projects/project_dashboard.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-projects-index') {
    const m = await import('../lib/page/reach/projects/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-projects-new') {
    const m = await import('../lib/page/reach/projects/create_project.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-segment-editor') {
    const m = await import('../lib/page/reach/segment-editor/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-segments-list') {
    const m = await import('../lib/page/reach/segments-list/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach-template-editor') {
    const m = await import('../lib/page/reach/template-editor/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach_beta-settings_my-teams') {
    const m = await import('../lib/page/reach/beta-settings/my-teams.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach_beta-settings_team-management') {
    const m = await import('../lib/page/reach/beta-settings/team-management.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reach_team-access') {
    const m = await import('../lib/page/reach/team-access/react.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_registration') {
    const m = await import('../lib/page/registration/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_registration_new') {
    const m = await import('../lib/page/registration/new/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_registration_setup-password') {
    const m = await import('../lib/page/registration/setup-password.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_registration_verify') {
    const m = await import('../lib/page/registration/verify/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_registration_two-part-signup') {
    const m = await import('../lib/page/registration/two-part-signup/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_response') {
    const m = await import('../lib/page/reports/containers/reports_response.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_unique_appopens') {
    const m = await import('../lib/page/reports/containers/unique_appopens.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reporting-hub') {
    const m = await import('../lib/page/reports/hub/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_app_metrics') {
    const m = await import('../lib/page/reports/containers/app-metrics.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_app_surveys') {
    const m = await import('../lib/page/reports/surveys/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_app_opens') {
    const m = await import('../lib/page/reports_app_opens.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_audience') {
    const m = await import('../lib/page/reports/containers/report_audience.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_audience_index') {
    const m = await import('../lib/page/reports_audience/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_custom_events') {
    const m = await import('../lib/page/reports/custom_events/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_emails_index') {
    const m = await import('../lib/page/reports/emails/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_sms_index') {
    const m = await import('../lib/page/reports/sms/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_web_push') {
    const m = await import('../lib/page/reports/web_push/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_omni-detail') {
    const m = await import('../lib/page/reports/omni-detail/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_opt_in') {
    const m = await import('../lib/page/reports_opt_in.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_pushes_sent') {
    const m = await import('../lib/page/reports_pushes_sent.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_reports_time_in_app') {
    const m = await import('../lib/page/reports_time_in_app.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_review_add_on') {
    const m = await import('../lib/page/manage-add-ons/review.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_rich_composer') {
    const m = await import('../lib/page/goatzart/richpush-editor.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_richpush-rpc') {
    const m = await import('../lib/page/richpush-rpc.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_localized_rich_composer') {
    const m = await import('../lib/page/scrooge/localized.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_sentry_feedback_form') {
    const m = await import('../lib/page/sentry-feedback-form.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_series') {
    const m = await import('../lib/page/zita/series-configure.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_series_builder') {
    const m = await import('../lib/page/zita/series-builder.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_sms_workflows') {
    const m = await import('../lib/page/sms-workflows/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_subscriber-lists-reports') {
    const m = await import('../lib/page/static-lists/subscriber-lists/Reports/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_tags') {
    const m = await import('../lib/page/tags/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_team_access') {
    const m = await import('../lib/page/team-access/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_team_management') {
    const m = await import('../lib/page/team-management/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_2fa_configuration') {
    const m = await import('../lib/page/2fa/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_test_devices') {
    const m = await import('../lib/page/test-devices/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_preference_centers') {
    const m = await import('../lib/page/preference-centers/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_test_users') {
    const m = await import('../lib/page/test-users/index.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_test_push') {
    const m = await import('../lib/page/test_push.js')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_zoltar') {
    const m = await import('../lib/page/zoltar/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_first_flight_invitation') {
    const m = await import('../lib/page/first-flight-invitation/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_dashboard') {
    const m = await import('../lib/page/reach/wallet-dashboard/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_reports') {
    const m = await import('../lib/page/reach/wallet-reports/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_settings_project_details') {
    const m = await import('../lib/page/reach/wallet-settings/project-details/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_settings_barcode') {
    const m = await import('../lib/page/reach/wallet-settings/barcode/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_settings_associated_app_ids') {
    const m = await import('../lib/page/reach/wallet-settings/app-ids/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_settings_api') {
    const m = await import('../lib/page/reach/wallet-settings/api/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_wallet_templates') {
    const m = await import('../lib/page/reach/wallet-templates/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auth_login_main') {
    const m = await import('../lib/page/auth/login/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auth_account_recovery') {
    const m = await import('../lib/page/auth/account-recovery/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auth_password_reset') {
    const m = await import('../lib/page/auth/password-reset/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auth_user_migration_interstitial') {
    const m = await import('../lib/page/auth/user-migration-interstitial/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'page_auth_user_callback_error') {
    const m = await import('../lib/page/auth/errors/index.tsx')
    loaded.push(m.default ?? m)
  }
  
if (module === 'prototype_example') {
    const m = await import('../lib/prototypes/example/index.ts')
    loaded.push(m.default ?? m)
  }
  
if (module === 'prototype_orc302') {
    const m = await import('../lib/prototypes/orc302/index.tsx')
    loaded.push(m.default ?? m)
  }
  
  }

  index(loaded)
}

loadModules()
  